/* import __COLOCATED_TEMPLATE__ from './lsg-circle-button-dropdown.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import clsx from 'clsx';

/**
 * Button types for the dropdown
 *
 * @type {Object}
 */
export const LSG_CIRCLE_BUTTON_TYPE = {
  ROUND: 'round', //normal round button
  FULL_WIDTH: 'full_width', //will take up the full width of the space.
};

/**
 * The different styles of the circle button dropdown
 *
 * @type {Object}
 */
export const LSG_CIRCLE_BUTTON__STYLE = {
  PRIMARY: 'primary', // main with yellow background and transparent hover.
  SECONDARY: 'secondary', // secondary with transparent background and yellow hover
  TERTIARY: 'tertiary', // tertiary with transparent background, no border, and transparent hover
};

/**
 * Alignments for the dropdown for the Materialize dropdown menu.  Corresponds to their dropdown docs.
 *
 * @type {Object}
 */
export const LSG_CIRCLE_BUTTON__ALIGNMENTS = {
  LEFT: 'left',
  RIGHT: 'right',
};

const MENU_ITEM_TYPES = {
  DEFAULT: '',
  SEPARATOR: 'separator',
};

export const LSG_CIRCLE_BUTTON_DROPDOWN = {
  MENU_ITEM_TYPES,
};

const CLASS_NAME = 'LSG-c-circle-button-dropdown';
const CLASS_NAME__FULL_WIDTH = `${CLASS_NAME}--full-width`;
const CLASS_NAME__SECONDARY = `${CLASS_NAME}--style-secondary`;
const CLASS_NAME__TERTIARY = `${CLASS_NAME}--style-tertiary`;

const TRIGGER_BUTTON_CLASS_NAME = `${CLASS_NAME}__menu-button`;
const TRIGGER_BUTTON_DISABLED_CLASS_NAME = `${TRIGGER_BUTTON_CLASS_NAME}--disabled`;

class LsgCircleButtonDropdown extends Component {
  @service router;

  get CLASS_NAME() {
    return CLASS_NAME;
  }

  get containerClass() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.args.buttonType === LSG_CIRCLE_BUTTON_TYPE.FULL_WIDTH && CLASS_NAME__FULL_WIDTH,
      this.args.buttonStyle === LSG_CIRCLE_BUTTON__STYLE.SECONDARY && CLASS_NAME__SECONDARY,
      this.args.buttonStyle === LSG_CIRCLE_BUTTON__STYLE.TERTIARY && CLASS_NAME__TERTIARY,
    );
  }

  get triggerClasses() {
    return clsx(
      'dropdown-trigger',
      TRIGGER_BUTTON_CLASS_NAME,
      this.args.disabled && TRIGGER_BUTTON_DISABLED_CLASS_NAME,
    );
  }

  get alignment() {
    return this.args.alignment ?? LSG_CIRCLE_BUTTON__ALIGNMENTS.RIGHT;
  }

  get menuItems() {
    return this.args.menuItems?.map((item) => {
      const props = { ...item };

      props.class = (props.type === LSG_CIRCLE_BUTTON_DROPDOWN.MENU_ITEM_TYPES.SEPARATOR || props.hasSeparatorAfter)
        ? 'has-separator-after'
        : null;

      if (props.link) {
        if (props.link.model && props.link.query) {
          props.url = this.router.urlFor(
            props.link.route,
            props.link.model,
            props.link.query
          );
        } else if (props.link.query) {
          props.url = this.router.urlFor(
            props.link.route,
            props.link.query
          );
        } else if (props.link.model) {
          props.url = this.router.urlFor(
            props.link.route,
            props.link.model
          );
        } else {
          props.url = this.router.urlFor(props.link.route);
        }
      }

      return props;
    });
  }

  get isButtonStyleTertiary() {
    return LSG_CIRCLE_BUTTON__STYLE.TERTIARY === this.args.buttonStyle;
  }

  @action
  onButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  @action
  onLinkClick(dropdown, menuItem, e) {
    e.preventDefault();
    e.stopPropagation();

    dropdown.actions.close();

    if (menuItem.link.model && menuItem.link.query) {
      return this.router.transitionTo(
        menuItem.link.route,
        menuItem.link.model,
        menuItem.link.query
      );
    } else if (menuItem.link.query) {
      return this.router.transitionTo(
        menuItem.link.route,
        menuItem.link.query
      );
    } else if (menuItem.link.model) {
      return this.router.transitionTo(
        menuItem.link.route,
        menuItem.link.model
      );
    }

    return this.router.transitionTo(menuItem.link.route);
  }

  @action
  onMenuClick(dropdown, fn, e) {
    e.preventDefault();
    e.stopPropagation();
    dropdown.actions.close();
    fn();
  }
}

export default LsgCircleButtonDropdown;
